import { schema } from "normalizr";

export const createEntity = (key, definition = {}, options = {}, ...args) =>
  new schema.Entity(key, definition, { idAttribute: "@id", ...options }, ...args);

export const CLIENT_TOKEN = process.env.REACT_APP_SHADOW_API_CLIENT_TOKEN;



// WEBPACK FOOTER //
// ./src/shadow-client/index.js